import { render, staticRenderFns } from "./OptionInputs.vue?vue&type=template&id=65cb682b&"
import script from "./OptionInputs.vue?vue&type=script&lang=js&"
export * from "./OptionInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65cb682b')) {
      api.createRecord('65cb682b', component.options)
    } else {
      api.reload('65cb682b', component.options)
    }
    module.hot.accept("./OptionInputs.vue?vue&type=template&id=65cb682b&", function () {
      api.rerender('65cb682b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/templates/OptionInputs.vue"
export default component.exports